import { Component, Input } from '@angular/core';

@Component({
    selector: 'bws-icon-list-item',
    templateUrl: './icon-list-item.component.html',
    styleUrls: ['./icon-list-item.component.css'],
    standalone: false
})
export class IconListItemComponent {

  @Input() icon: string = '';
  @Input() left: string = '';
  @Input() leftSubtitle: string = '';
  @Input() right: string = '';

}
